import { render, staticRenderFns } from "./SingleImage.vue?vue&type=template&id=00cd1d1a&scoped=true"
import script from "./SingleImage.vue?vue&type=script&lang=js"
export * from "./SingleImage.vue?vue&type=script&lang=js"
import style0 from "./SingleImage.vue?vue&type=style&index=0&id=00cd1d1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cd1d1a",
  null
  
)

export default component.exports